import { useExperiment } from '@statsig/react-bindings';

const useFixedHeader = () => {
  return useExperiment('fixed_header').get('fixed', false);
};

export default useFixedHeader;
